import { gql } from 'graphql-request';

import {
  CategoryID,
  CategoryUUID,
  CategoryNameEn,
  CategoryLocalizedName
} from '../../categories/categoriesTypes';

export interface FetchProductColorsQueryResponse {
  uuid: CategoryUUID;
  id: CategoryID;
  nameEn: CategoryNameEn;
  localizedName: CategoryLocalizedName;
}

export const FETCH_CACHE_PRODUCT_COLORS_QUERY = gql`
  query CacheProductColorsCategories(
    $filters: CategoriesFilters
    $sort: [CategoriesSortEnum!]
    $limit: Int
    $offset: Int
    $source: String
    $trackTotalHits: Boolean
  ) {
    categories(
      filters: $filters
      sort: $sort
      limit: $limit
      offset: $offset
      source: $source
      trackTotalHits: $trackTotalHits
    ) {
      nodes {
        uuid
        id
        nameEn
        localizedName
      }
      sql
    }
  }
`;
